<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">{{ 'ViewItemData' | translate}}</h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <mat-card class="cardWithShadow" *ngIf="ItemInfo">
        <mat-card-content>
            <div class="container">
                <div class="profile-header">
                    <img src="{{ItemInfo.imgURL | adjust_image_path}}" alt="{{ItemInfo.productName}}"
                        *ngIf="ItemInfo.imgURL">
                    <img src="../../../../assets/images/avatar-placeholder.png" alt="{{ItemInfo.productName}}"
                        *ngIf="!ItemInfo.imgURL">
                    <h3>{{ItemInfo.productName}}</h3>
                </div>

                <div class="info">
                    <h4>{{ 'ItemInformation' | translate }}</h4>
                    <p>
                        <mat-label class="spanTitle">{{ 'Category' | translate }} : </mat-label>
                        {{ItemInfo.categoryName}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'Color' | translate }} : </mat-label>
                        {{ItemInfo.colorName}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'measruingUnit' | translate }} : </mat-label>
                        {{ItemInfo.typeOfProductName}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'ProductName' | translate }} : </mat-label>
                        {{ItemInfo.productName}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'ProductCode' | translate }} : </mat-label>
                        {{ItemInfo.productCode}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'metersPerRod' | translate }} : </mat-label>
                        {{ItemInfo.metersPerRod}} {{ 'Meter'|translate }}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'TotalQuota' | translate }} : </mat-label>
                        {{ItemInfo.totalQuota}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'pricePerOne' | translate }} : </mat-label>
                        {{ItemInfo.pricePerOne}} {{ 'EGP' | translate}}
                    </p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-divider></mat-divider>
    <div class="row m-t-24">
        <div class="col-sm-12">
            <button mat-button class="Cancelbtn" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
        </div>
    </div>
</mat-dialog-content>